import React, { useState } from "react";
import {
  Avatar,
  Badge,
  Box,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Typography,
  Container,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PhotoCameraIcon from "@material-ui/icons/PhotoCamera";
import coverImg from "./backgroundCover.webp";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { appUrl } from "../../../../../../utils/config";
import axios from "axios";
const useStyles = makeStyles((theme) => ({
  backdrop: {
    // zIndex: theme.zIndex.drawer + 10,
    zIndex: 50000,
    // color: '#fff',
  },
  coverContainer: {
    position: "relative",
    width: "100%",
  },
  coverImg: {
    width: "100%",
    height: "12vh",
    objectFit: "cover",
  },
  avatarContainer: {
    position: "absolute",
    left: "10%",
    bottom: "-15%",
    transform: "translateX(-50%)",
  },
  avatar: {
    width: "60px",
    height: "60px",
    // backgroundColor: "#3f51b5",
  },
  uploadButton: {
    position: "absolute",
    bottom: -5,
    right: -5,
    padding: 4,
    backgroundColor: "#ec6535",
    "&:hover": {
      backgroundColor: "#e0e0e0",
    },
  },
  cameraIcon: {
    fontSize: "16px",
    color: "white",
  },
  dialog: {
    // Target the dialog root
    // zIndex: 60000,
    zIndex: `${theme.zIndex.drawer + 1000} !important`, // Higher than drawers
    "& .MuiPaper-root": {
      borderRadius: "16px", // Rounded corners
    },
  },
  dialogTitle: {
    padding: "24px 24px 0", // Adjust padding
    textAlign: "center", // Center the title
  },
  titleText: {
    // Style the title text
    fontWeight: 600,
    fontSize: "1.5rem", // Adjust as needed
    color: "#212121", // Darker text color
  },
  checkIcon: {
    color: "#008002", // Green color
    fontSize: "3rem", // Large icon size
    marginBottom: "1rem", // Space below icon
  },
  dialogContent: {
    padding: "20px 24px 24px", // Adjust padding
    textAlign: "center", // Center content
  },
  contentText: {
    color: "#424242", // Slightly lighter text
  },
  dialogActions: {
    padding: "16px", // Adjust padding
    justifyContent: "center", // Center the button
  },
  okButton: {
    backgroundColor: "#ec6535", // Orange background
    color: "white", // White text
    textTransform: "none", // Remove uppercase transform
    padding: "8px 30px", // Adjust padding for pill shape
    minWidth: "100px", // optional, set min width for button
    borderRadius: "20px", // Slightly rounded corners
    "&:hover": {
      backgroundColor: "#ec6535", // Darker orange on hover
    },
  },
}));

const Cover = ({ profilePic, handleRefresh, user, setViewDetailsDrawer }) => {
  const classes = useStyles();
  const [base64URL, setBase64URL] = useState(profilePic || "");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showDialog, setShowDialog] = useState(false);

  const handleOk = () => {
    setShowDialog(false);
    setLoading(false);
    setViewDetailsDrawer(false);
    handleRefresh();
  };
  const uploadImage = (image) => {
    const requestObject = [
      {
        saas_user_id: user.saas_user_id,
        profile_pic: image,
      },
    ];
    // console.log("🚀 ~ handleConfirm ~ requestObject:", requestObject);
    // const url = "/updateUserDetails";
    const url = `${appUrl}/user/updateTeamMemberDetails`;
    setLoading(true);
    setError(null);
    axios
      .post(url, requestObject)
      .then((res) => {
        // throw new Error("Mock Error");
        if (res.data.status) {
          handleClose();
          setShowDialog(true);
        } else {
          setError("Update failed");
        }
      })
      .catch((err) => {
        //console.log("API Error", err.message);
        setError(err.message || "An error occurred");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleImageUpload = (event) => {
    setLoading(true);
    const file = event.target.files[0]; // Get the selected file
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file); // Convert to Base64
      reader.onload = () => {
        // setBase64URL(reader.result); // Set Base64 URL
        uploadImage(reader.result);
      };
      reader.onerror = (error) => {
        console.error("Error converting image to Base64:", error);
        setError("Something went wrong");
      };
    }
  };
  const handleClose = () => {
    setLoading(false);
    setShowDialog(true);
  };
  const displayError = (
    <Container>
      <Box
        style={{
          border: "2px solid rgb(255,0,0)",
          backgroundColor: "rgb(255,240,240)",
          textAlign: "center",
          padding: "0.8rem",
          fontSize: "0.875rem",
          marginTop: "1.5em",
        }}
      >
        {" "}
        <Typography variant="body2">
          Something went wrong. Please try again later.
        </Typography>
      </Box>
    </Container>
  );
  if (error) return displayError;
  return (
    <Box className={classes.coverContainer}>
      <img className={classes.coverImg} src={coverImg} alt="cover image" />

      <Box className={classes.avatarContainer}>
        <Badge
          overlap="circular"
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          badgeContent={
            <label htmlFor="image-upload">
              <IconButton component="span" className={classes.uploadButton}>
                <PhotoCameraIcon className={classes.cameraIcon} />
              </IconButton>
            </label>
          }
        >
          <Avatar className={classes.avatar} src={base64URL} />
        </Badge>
        <input // Hidden input for file selection
          id="image-upload"
          type="file"
          accept="image/*" // Accept only image files
          style={{ display: "none" }}
          onChange={handleImageUpload}
        />
      </Box>

      {/* Backdrop */}
      <Backdrop
        className={classes.backdrop}
        open={loading}
        // onClick={handleClose}
      >
        <CircularProgress />
      </Backdrop>

      {/* Dialog */}
      <Dialog
        open={showDialog}
        keepMounted
        onClose={() => setShowDialog(false)}
        className={classes.dialog}
        fullWidth={true}
        maxWidth="sm"
      >
        <DialogTitle className={classes.dialogTitle}>
          <CheckCircleIcon className={classes.checkIcon} />
          <Typography variant="h6" className={classes.titleText}>
            {" "}
            {/* Style the title */}
            Success
          </Typography>
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <DialogContentText className={classes.contentText}>
            Profile picture updated successfully
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button
            onClick={handleOk}
            className={classes.okButton}
            variant="contained"
            endIcon={<ChevronRightIcon>send</ChevronRightIcon>}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Cover;
